import React from 'react'

type DraggedMomentParams = {
  id: string
  scheduledAt: Date | string
  primaryStoryInterval: {
    start: Date
    end: Date
  } | null
}

type MomentDragContextValue = {
  draggedMoment: DraggedMomentParams | null
  setDraggedMoment: React.Dispatch<
    React.SetStateAction<DraggedMomentParams | null>
  >
}

export const MomentDragContext = React.createContext<
  MomentDragContextValue | undefined
>(undefined)

export const MomentDragContextProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const [draggedMoment, setDraggedMoment] =
    React.useState<DraggedMomentParams | null>(null)

  return (
    <MomentDragContext.Provider
      value={{
        draggedMoment,
        setDraggedMoment: setDraggedMoment,
      }}
    >
      {children}
    </MomentDragContext.Provider>
  )
}

export const useMomentDragContext = (): MomentDragContextValue => {
  const context = React.useContext(MomentDragContext)

  if (context === undefined) {
    throw new Error(
      'useMomentDragContext must be used inside a MomentDragContextProvider.'
    )
  }

  return context
}
